import userActions from './userActions'
import menuActions from './menuActions'

const allActions = {
  userActions,
  menuActions,
}

export default allActions
